export default {
  title: {
    en: 'Report problem with billing and get next month for free.',
  },
  successMessage: {
    en: `Thank you for your message. Your discount <strong>has been applied</strong>. We’ll reply within 24 Hours. Check out your email on <strong>{date}</strong>.`,
  },
}
